import { LSK } from '@shared/utils/storage/config';
import { isA1App } from '../platform/platformDetection';
import { isMobile } from 'react-device-detect';

export default class GoogleTrack {
	// 判断当前用户是否来自api 投流渠道
  public static isApiAd = () => {
		const source = localStorage.getItem(LSK.SOURCE);
		const plan = localStorage.getItem(LSK.PLAN);
		if (!source || !plan) return false; 
		return source.includes('A1_gg') && plan.includes('a1api');
	};

	// 访问回传
	public static visitTrack = () => {
		if (isMobile) return;
		window.gtag('event', 'conversion', { send_to: 'AW-16466063410/QmTwCLrgp8YaELLg0Ks9' });
	};

	// 注册回传
	public static registerTrack = () => {
		if (isMobile) return;
		window.gtag('event', 'conversion', { send_to: 'AW-16466063410/9dcTCPjlscYaELLg0Ks9' });
	};

	// 订阅回传
	public static subscribeTrack = () => {
		if (isA1App) return;
		const isTracked = localStorage.getItem(LSK.GOOGLE_REPORTED_SUBSCRIBE);
		if (isTracked) return;
		window.gtag('event', 'conversion', { send_to: 'AW-16466063410/mvyQCLPHp8YaELLg0Ks9' });
		localStorage.setItem(LSK.GOOGLE_REPORTED_SUBSCRIBE, 'true');
	};
}
